export const SELECT_PAGE_OVER = 'REPORTING_SELECT_PAGE_OVER';

export const selectPageOver = pageIndex => ({
  type: SELECT_PAGE_OVER,
  pageIndexOver: pageIndex,
});
